import { useState } from "react";
import Cursor from "../components/Cursor";
import Footer from "../components/Footer";
import Transitionner from "../components/Transitionner";
import Navbar from "../layouts/Navbar";

import "./styles/basePage.css"
import { useLocation, useNavigate } from "react-router-dom";
import List from "../components/List";
import Title from "../components/Title";

export default function Projects() {
    const [isAnimate, changeAnimationState] = useState(false);
    const [isAppearing, changeAppearing] = useState(false);
    const [isPageLocked, changeLockPage] = useState(true);

    const delayedAppears = () => {
        changeAppearing(true);
    }
    setTimeout(delayedAppears, 500);

    const unlockPage = () => {
        changeLockPage(false);
    }

    setTimeout(unlockPage, 3100);

    
    const lockPage = () => {
        changeLockPage(true);
    }


    let location = useLocation()
    const navigate = useNavigate()
    
    const handleClick = (url) => {
        if(url !== location.pathname) {
            changeAnimationState(true);
            lockPage()
            setTimeout(() => {
                navigate(url)
            }, 1000)
        }
    }

    
    return (
        <div className={`page${isPageLocked ? " locked" : ""}`}>
            <Transitionner isAnimate={isAnimate} isAppearing={isAppearing} />

            <Cursor fadeOut={isAnimate}/>
            <Navbar fadeOut={isAnimate} actionHandler={handleClick} />
            <div className="spacer" style={{
                marginTop: 100,
                marginBottom: 100
            }}>
                <Title fadeOut={isAnimate} content={"Mes Projets"} />
                <List fadeOut={isAnimate} />
            </div>
            <Footer fadeOut={isAnimate} />
        </div>
    );
};